// Estado vacio (rediseño, docs/PLAN-REDISENO-PORTAL.md §6.9): un icono en
// caja punteada, un titulo corto, por que esta vacio y, si corresponde, la
// accion. Nunca una linea gris sola: el operador tiene que saber que no se
// perdio nada y que viene despues.
import { cn } from "./cn.js";
import { Icon, type IconName } from "./icon.js";

interface Props {
  icon?: IconName;
  title: string;
  children?: React.ReactNode;
  /** Botones o enlaces, ya armados. */
  actions?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon = "bandeja", title, children, actions, className }: Props): React.JSX.Element {
  return (
    <div role="status" className={cn("flex flex-col items-center gap-1.5 px-4 py-7 text-center", className)}>
      <span aria-hidden="true" className="mb-1 grid size-9 place-items-center rounded-lg border border-dashed border-linea-fuerte text-texto-suave">
        <Icon name={icon} className="size-[18px]" />
      </span>
      <p className="m-0 text-sm font-semibold text-texto">{title}</p>
      {children !== undefined && <div className="m-0 max-w-[46ch] text-sm leading-normal text-texto-suave">{children}</div>}
      {actions !== undefined && <div className="mt-1.5 flex flex-wrap justify-center gap-2">{actions}</div>}
    </div>
  );
}
